interface TextInputWithIconComponentProps {
  id: string;
  divClassName?: string;
  name: string;
  type: string;
  icon: string;
  iconClassName?: string;
  placeholder: string;
  value: string;
  textClassName?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function TextInputWithIconComponent(props: TextInputWithIconComponentProps) {
  return (
    <>
      <label htmlFor={props.id} className="sr-only">
        {props.placeholder}
      </label>
      <div className={props.divClassName ?? ""}>
        <img className={props.iconClassName ?? ""} src={props.icon} alt="password icon" width={16} height={16} />
        <input
          id={props.id}
          name={props.name}
          type={props.type}
          required
          className={props.textClassName ?? ""}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
        />
      </div>
    </>
  );
}
